import { render, staticRenderFns } from "./memberForm.vue?vue&type=template&id=3b6cb086&scoped=true&"
import script from "./memberForm.vue?vue&type=script&lang=babel&"
export * from "./memberForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cb086",
  null
  
)

export default component.exports